import { Component } from "react";
import Layout from "../../component/layout";
import NextSeoModule from "../../component/next-seo";
import Trellotemplate from "../../component/course/trello";


export default class Trelloinnagercoil extends Component {
 
  render() {
  
    const title = "Trello"   
    const url1 ="-training-in-nagercoil"
    const location = "nagercoil" 
    const location1="Training in Nagercoil"
    const url ="trello"
     return(
      <>
          <NextSeoModule
            title={`${title} ${location1} - learnsoft.org`}
            description={`Learn Trello in ${location} with Learnsoft.org! Our comprehensive training program covers everything from basics to advanced Trello features. Enroll now and master Trello like a pro!`}
            url={`${location}/${url}${url1}`}
            img={`course/${url}.webp`}
             keyword={`${title} training in ${location}, ${title} certification in ${location}, Online ${title}  Training in ${location}, ${title} Online Training in ${location}, ${title} Syllabus, ${title} course in ${location}, ${title} classes in ${location}, ${title} institute in ${location}, Best ${title} training institute in ${location}, ${title} training and certification in ${location}, Best ${title} training in ${location}, ${title} coaching in ${location}, ${title} training center in ${location}, ${title} training provider in ${location}`}
          />
        <Layout navbarBackgroundColor="#281E1E">
          <Trellotemplate url={url} title={title} url1={url1} relatedlocation={location} location={location} location1={location1} />
       </Layout>
      </>
    );
  }
}
